/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirm_Purchase_TitleInputs */

const en_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Purchase`)
};

const ar_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد الشراء`)
};

const de_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf bestätigen`)
};

const es_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar compra`)
};

const fr_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'achat`)
};

const it_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma Acquisto`)
};

const ja_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入内容の確認`)
};

const ko_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 확인`)
};

const pt_br_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar compra`)
};

const ru_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить покупку`)
};

const th_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันการซื้อ`)
};

const tr_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın Alma İşlemini Onayla`)
};

const zh_cn_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认购买`)
};

const zh_tw_dialog_confirm_purchase_title = /** @type {(inputs: Dialog_Confirm_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認購買`)
};

/**
* | output |
* | --- |
* | "Confirm Purchase" |
*
* @param {Dialog_Confirm_Purchase_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirm_purchase_title = /** @type {((inputs?: Dialog_Confirm_Purchase_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirm_Purchase_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirm_purchase_title(inputs)
	if (locale === "ar") return ar_dialog_confirm_purchase_title(inputs)
	if (locale === "de") return de_dialog_confirm_purchase_title(inputs)
	if (locale === "es") return es_dialog_confirm_purchase_title(inputs)
	if (locale === "fr") return fr_dialog_confirm_purchase_title(inputs)
	if (locale === "it") return it_dialog_confirm_purchase_title(inputs)
	if (locale === "ja") return ja_dialog_confirm_purchase_title(inputs)
	if (locale === "ko") return ko_dialog_confirm_purchase_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirm_purchase_title(inputs)
	if (locale === "ru") return ru_dialog_confirm_purchase_title(inputs)
	if (locale === "th") return th_dialog_confirm_purchase_title(inputs)
	if (locale === "tr") return tr_dialog_confirm_purchase_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirm_purchase_title(inputs)
	return zh_tw_dialog_confirm_purchase_title(inputs)
});